import React from 'react'

const ImageBorderStyleRight = (props) => {
  return (
  <>
  <section className="container-fluid py-lg-5 pb-4">
    <div className="row justify-content-center gy-4">
      <div className="col-11 col-lg-5 position-border-2 d-none d-lg-block">
        <img src={props.Img} alt="" className="w-100" />
      </div>
      <div className="col-11 col-lg-5 border-style-left">
        <div className='pt-lg-5 pe-lg-3 ps-lg-5'>
        <div className="fs-ss-30 fw-800 text-ss-primary text-philos">
        {props.Title}
        </div>
        <div className="fs-ss-16 fw-500 text-mulish lh-lg text-black fst-bold">
        {props.Para}
        </div>
        </div>
      </div>
      <div className="col-11 col-lg-5 position-border-2 d-block d-lg-none">
        <img src={props.Img} alt="" className="w-100" />
      </div>
    </div>
  </section>
  </>
  )
}

export default ImageBorderStyleRight